<span
  class="initials-avatar"
  [style.width.px]="size"
  [style.height.px]="size"
  [style.font-size.px]="fontSize"
  [style.background]="backgroundColor"
  [style.color]="textColor"
  [attr.aria-label]="ariaLabel"
>
  {{initials}}
</span>
